import React, { useEffect } from "react";
import "./App.css";
import {
  Route,
  BrowserRouter,
  Routes,
  Outlet,
  Navigate,
  useLocation,
} from "react-router-dom";
import StorelistPage from "./modules/storelist/components/StorelistPage";
import "./modules/comman/components/CommanPage.css";
import VendordashboardPage from "./modules/dashboard/components/VendordashboardPage";
import Landing from "./modules/landingoutlet/components/Landing";
import StoredetailPage from "./modules/storedetail/components/StoredetailPage";
import OrderlistPage from "./modules/orderlist/components/OrderlistPage";
import NotificationPage from "./modules/notification/components/NotificationPage";
import AddproductPage from "./modules/products/components/AddproductPage";
import ProductlistPage from "./modules/products/components/ProductlistPage";
import LoginPage from "./modules/login/components/LoginPage";
import ForgotPage from "./modules/forgot/components/ForgotPage";
import SignupPage from "./modules/signup/components/SignupPage";
import TransactionPage from "./modules/transaction/components/TransactionPage";
import OfferslistPage from "./modules/offers/components/OfferslistPage";
import AddofferPage from "./modules/offers/components/AddofferPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import SettingsPage from "./modules/settings/components/SettingsTabs";
import VendorsignupPage from "./modules/vendorsignup/components/VendorsignupPage";
import BusinesssetupPage from "./modules/businesssetup/components/BusinesssetupPage";
import ShoppingcardPage from "./modules/shoppingcard/components/ShoppingcardPage";
import PaymentdetailPage from "./modules/paymentdetail/components/PaymentdetailPage";
import CheckoutPage from "./modules/checkout/components/CheckoutPage";
import OrderdetailPage from "./modules/orderdetail/components/OrderdetailPage";
import UserDashboardPage from "./modules/user/dashboard/components/DashboardPage";
import UserLandingPage from "./modules/user/landing/components/LandingPage";
import MyordersPage from "./modules/user/myorders/components/MyordersPage";
import ProductdetailPage from "./modules/productdetail/components/ProductdetailPage";
import HomePage from "./modules/home/components/HomePage";
import StoreoffersPage from "./modules/storeoffers/components/StoreoffersPage";
import CatelogPage from "./modules/catalog/components/CatelogPage";
import EditCatalogproductPage from "./modules/catalog/components/EditCatalogproductPage";
import DeliverychargesPage from "./modules/deliverycharges/components/DeliverychargesPage";
import SubcatalogPage from "./modules/catalog/components/SubcatalogPage";
import CataProductPage from "./modules/catalog/components/CataProductPage";
import CategoryPage from "./modules/categorys/components/CategoryPage";
import WishlistTabs from "./modules/user/wishlist/components/WishlistTabs";
import SessionremovePage from "./modules/sessionremove/components/SessionremovePage";
import UsefulPage from "./modules/pages/components/UsefulPage";
import FaqsPage from "./modules/pages/components/FaqsPage";
import ResentpasswordPage from "./modules/resetpassword/components/ResentpasswordPage";
import SeoPages from "./modules/seoroute/components/SeoPages";
import VehiclelistPage from "./modules/vehicle/vehiclelistPage/components/VehiclelistPage";
import DriverdetailPage from "./modules/vehicle/driverdetail/components/DriverdetailPage";
import MyridePage from "./modules/vehicle/myrides/components/MyridePage";
import ReviewsPage from "./modules/reviews/components/ReviewsPage";
import ProfilePage from "./modules/profile/components/ProfilePage";
import HeaderPage from "./modules/header/components/HeaderPage";
import FooterPage from "./modules/footer/components/FooterPage";
import UserlistPage from "./modules/chat/components/UserlistPage";
import { useState } from "react";
import SitemapPage from "./modules/pages/components/SitemapPage";
import ContactusPage from "./modules/pages/components/ContactusPage";
import ViewcartboxPage from "./modules/comman/components/ViewcartboxPage";
import dateFnsEnUS from 'date-fns/locale/en-US';
import dateFnsTr from 'date-fns/locale/tr';
import { registerLocale } from "react-datepicker";
import VerifyUserLiveLocation from "./modules/comman/components/VerifyUserLiveLocation";
registerLocale('en', dateFnsEnUS);
registerLocale('tr', dateFnsTr);
function App() {

  var [color,setColor] = useState("");

  var[showheader,setShoheader] = useState(false);
 
  const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
      colorChange(pathname);
    }, [pathname]);
    return null;
  };

  const colorChange = (pathname) => {
      let getValue = pathname.split("/").pop()
      switch (getValue) {
        case "partner":
          setColor("transparent");
          break;
        case "checkout":
          setColor("transparent");
          break;
        case "login":
          setColor("white");
          break;
          case "stores":
          setColor("transparent");
          break;
        case "payment":
          setColor("transparent");
          break; 
        case "cart":
          setColor("transparent");
          break;
        case "offers":
          setColor("transparent");
          break;
        case "contact-us":
          setColor("transparent");
          break;
        default:
          setColor("white");
          break;
      }
     let showheader = pathname.split("/")
     if(showheader[1] === "admin-chat" || showheader[1] === "chat") {
        setShoheader(true);
     }else{
      setShoheader(false);
     }
  }

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
         {!showheader && <HeaderPage headerBackground={color}/>} 
          <ScrollToTop />
          <SessionremovePage />
          <ToastContainer />
          <ViewcartboxPage />
          <SeoPages />
          <VerifyUserLiveLocation/>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="category" element={<CategoryPage />} />
            <Route exact path="/stores/:id?" element={<StorelistPage />} />
            <Route path="/detail/:id" element={<StoredetailPage />} />
            <Route path="product-detail/:id" element={<ProductdetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot" element={<ForgotPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/business-setup" element={<BusinesssetupPage />} />
            <Route path="/partner" element={<VendorsignupPage />} />
            <Route path="/cart" element={<ShoppingcardPage />} />
            <Route path="/payment" element={<PaymentdetailPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/offers" element={<StoreoffersPage />} />
            <Route
              path="/password/reset/:id"
              element={<ResentpasswordPage />}
            />
            <Route exact path="/vendor" element={<Landing />}>
              <Route
                exact
                element={<Navigate to={"dashboard"} replace={true} />}
              />
              <Route path="dashboard" element={<VendordashboardPage />} />
              <Route path="charges" exact element={<DeliverychargesPage />} />
              <Route path=":id?" exact element={<BusinesssetupPage />} />
              <Route path="products" exact element={<Outlet />}>
                <Route path="catalog" exact element={<Outlet />}>
                  <Route index exact element={<CatelogPage />} />
                  <Route
                    path="edit"
                    exact
                    element={<EditCatalogproductPage />}
                  />
                  <Route path="product" exact element={<CataProductPage />} />
                  <Route path=":id" exact element={<SubcatalogPage />} />
                </Route>
                <Route
                  index
                  exact
                  element={<ProductlistPage maincontent={true} />}
                />
                <Route path="add" exact element={<AddproductPage />} />
                <Route path=":id" exact element={<AddproductPage />} />
              </Route>
              <Route path="orders" exact element={<Outlet />}>
                <Route
                  index
                  exact
                  element={<OrderlistPage dashboard={false} />}
                />
                <Route path=":id" exact element={<OrderdetailPage />} />
              </Route>
               <Route
                path="notifications"
                exact
                element={<NotificationPage dashboard={false} />}
              />
              <Route path="transaction" exact element={<TransactionPage />} />
              <Route path="review" exact element={<ReviewsPage />} />
              <Route path="settings" exact element={<SettingsPage />} />
              <Route path="offers" exact element={<Outlet />}>
                <Route index exact element={<OfferslistPage />} />
                <Route path="add" exact element={<AddofferPage />} />
                <Route path=":id" exact element={<AddofferPage />} />
              </Route>
              <Route
                exact
                path="rides/:id"
                element={<MyridePage dashboard={false} />}
              ></Route>
            </Route>
             <Route exact path="/user" element={<UserLandingPage />}>
              <Route
                index
                exact
                element={<Navigate to={"dashboard"} replace={true} />}
              />
              <Route path={"dashboard"} element={<UserDashboardPage />} />
              <Route path="myorders" exact element={<Outlet />}>
                <Route index exact element={<MyordersPage />} />
                <Route path=":id" exact element={<OrderdetailPage />} />
              </Route>
              <Route
                exact
                path="notifications"
                element={<NotificationPage dashboard={false} />}
              />
              <Route exact path="review" element={<ReviewsPage />} />
              <Route exact path="wishlist" element={<WishlistTabs />} />
              <Route exact path="settings" element={<ProfilePage />} />
              <Route
                exact
                path="my-rides"
                element={<MyridePage dashboard={false} />}
              />
            </Route>
            <Route exact path="pages" element={<Outlet />}>
              <Route exact path="about-us" element={<UsefulPage />} />
              <Route exact path="terms-conditions" element={<UsefulPage />} />
              <Route exact path="privacy-policy" element={<UsefulPage />} />
              <Route exact path="app-faqs/:lang" element={<FaqsPage />} />
              <Route exact path="faqs" element={<FaqsPage />} />
              <Route exact path="return-policy" element={<UsefulPage />} />
              <Route exact path="shipping-policy" element={<UsefulPage />} />
              <Route exact path="site-map" element={<SitemapPage/>}/>
              <Route exact path="contact-us" element={<ContactusPage/>}/>
            </Route>
             <Route exact path="/chat/:id" element={<UserlistPage />}></Route> 
             <Route
              exact
              path="/admin-chat/*"
              element={<UserlistPage />}
            ></Route>
            <Route path="/cabs" element={<VehiclelistPage />} />
            <Route path="/cab-book/:id" element={<DriverdetailPage />} />
          </Routes>
         {!showheader && <FooterPage />}
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
